export type CardSizePreset = 'small' | 'medium' | 'large' | 'wide';

export const CARD_SIZE_PRESETS: Record<
  CardSizePreset,
  { w: number; h: number; minW: number; minH: number }
> = {
  small: { w: 3, h: 2, minW: 2, minH: 2 },
  medium: { w: 4, h: 3, minW: 3, minH: 2 },
  large: { w: 6, h: 4, minW: 4, minH: 3 },
  wide: { w: 8, h: 3, minW: 6, minH: 2 },
};

export interface GridLayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
  maxW?: number;
  maxH?: number;
  static?: boolean;
  isDraggable?: boolean;
  isResizable?: boolean;
}

export interface DashboardGridConfig {
  cols: number;
  rowHeight: number;
  margin: [number, number];
  containerPadding: [number, number];
}

export const DEFAULT_GRID_CONFIG: DashboardGridConfig = {
  cols: 12,
  rowHeight: 100,
  margin: [16, 16],
  containerPadding: [0, 0],
};

export function getCardSizePreset(w: number, h: number): CardSizePreset {
  if (w >= 8) return 'wide';
  if (w >= 6 || h >= 4) return 'large';
  if (w >= 4 || h >= 3) return 'medium';
  return 'small';
}

export function getSizePresetDimensions(
  preset: CardSizePreset
): { w: number; h: number } {
  const { w, h } = CARD_SIZE_PRESETS[preset];
  return { w, h };
}
